<template>
  <div>
    <imgHeader imgUrl="/img/8企业文化-banner.jpg" />
    <div class="w">
      <h3 class="title" style="text-align: center;">{{ $t('companyCulture.title') }}</h3>
      <div class="line line1"></div>
      <div class="culture">
        <div
            class="card flex right"
            data-aos="fade-right"
            data-aos-offset="300"
            data-aos-duration="1000"
        >
          <div class="desc">
            <h3 class="desc-title">{{ $t('companyCulture.quality_title') }}</h3>
            <p>{{ $t('companyCulture.quality_desc1') }}</p>
            <p>{{ $t('companyCulture.quality_desc2') }}</p>
          </div>
          <img src="/img/8企业文化-img1.jpg" alt="" />
        </div>
        <div
            class="card flex"
            data-aos="fade-left"
            data-aos-offset="300"
            data-aos-duration="1000"
        >
          <img src="/img/8企业文化-img2.jpg" alt="" />
          <div class="desc">
            <h3 class="desc-title">{{ $t('companyCulture.taste_title') }}</h3>
            <p>{{ $t('companyCulture.taste_desc1') }}</p>
            <p>{{ $t('companyCulture.taste_desc2') }}</p>
          </div>
        </div>
        <div
            class="card flex right"
            data-aos="fade-right"
            data-aos-offset="300"
            data-aos-duration="1000"
        >
          <div class="desc">
            <h3 class="desc-title">{{ $t('companyCulture.morality_title') }}</h3>
            <p>{{ $t('companyCulture.morality_desc1') }}</p>
            <p>{{ $t('companyCulture.morality_desc2') }}</p>
          </div>
          <img src="/img/8企业文化-img3.jpg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyCulture',
}
</script>

<style scoped lang="scss">
.culture {
  margin-top: 64px;
  margin-bottom: 90px;
  overflow: hidden;
}
.card {
  width: 960px;
  height: 400px;
  margin-bottom: 60px;
  box-shadow: 0 0 20px var(--bg-color);
}
.desc {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 30px;
  p {
    margin: 0;
    line-height: 1.6;
  }
}
.desc-title {
  margin-bottom: 64px;
}
.left {
  float: left;
}
.right {
  float: right;
}
</style>